import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = (response, context) => {
  context.hold_eventLoading = false;
  context.closeModal ('#export-analysis-modal');
  toastr.success(context.$t('analytics.index.export_analysis.superbudged_generated_successfully'));
};

// When the request fails
const failed = (error, context) => {
    context.hold_eventLoading = false;
    context.showToasterError(error);
};

export default (context, analytics) => {
  return Vue.$http.post('/analytics/export-csv', analytics)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed();
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/analytics/generateAnalyticsCsv.js